module.exports = __webpack_public_path__ + "img/logo@2x.35918754.png";